<script>
import baseInput from '@/components/form/input/'
export default {
    name: 'EmailInput',
    extends: baseInput,
    props: {
        type: {
            type: String,
            default: 'email',
            validator: (value) => ['email'].includes(value),
        },
        // The error to display if we don't have a specific error to render.
        defaultErrorText: {
            type: String,
            default: 'Please enter a valid Email',
        },
        disableEmailSniffer: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        internalValue: {
            get() {
                // eslint-disable-next-line valid-typeof
                if (this.value && typeof this.value === String) return this.value.trim()
                return this.value
            },
            set(newVal) {
                if (newVal) newVal = newVal.trim()
                this.$emit('input', newVal)
            },
        },
    },
    methods: {
        extendedValidator() {
            const email = this.internalValue.trim()
            // eslint-disable-next-line no-useless-escape
            const test = /^.+\@.+\..+$/.test(email)
            return test
        },
    },
}
</script>
